import * as Constants from './constants'

export const productsListRequest = (formData) => {
  return {
    type: Constants.PRODUCTS_LIST_REQUESTING,
    payload: formData
  }
}

export const productsListSuccess = (data) => {
  return {
    type: Constants.PRODUCTS_LIST_SUCCESS,
    data
  }
}

export const productsListError = (error) => {
  return {
    type: Constants.PRODUCTS_LIST_ERROR,
    error
  }
}

export const productsDetailRequest = (formData) => {
  return {
    type: Constants.PRODUCTS_DETAIL_REQUESTING,
    payload: formData
  }
}

export const productsDetailSuccess = (data) => {
  return {
    type: Constants.PRODUCTS_DETAIL_SUCCESS,
    data
  }
}

export const productsDetailError = (error) => {
  return {
    type: Constants.PRODUCTS_DETAIL_ERROR,
    error
  }
}

export const productsUpdateRequest = (formData, callback) => {
  return {
    type: Constants.PRODUCTS_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const productsUpdateSuccess = (response) => {
  return {
    type: Constants.PRODUCTS_UPDATE_SUCCESS,
    payload: response
  }
}

export const productsUpdateError = (error) => {
  return {
    type: Constants.PRODUCTS_UPDATE_ERROR,
    error
  }
}

export const productsRemoveRequest = (formData, callback) => {
  return {
    type: Constants.PRODUCTS_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const productsRemoveSuccess = (response) => {
  return {
    type: Constants.PRODUCTS_REMOVE_SUCCESS,
    payload: response
  }
}

export const productsRemoveError = (error) => {
  return {
    type: Constants.PRODUCTS_REMOVE_ERROR,
    error
  }
}

export const productsExportXlsRequest = (formData, callback) => {
  return {
    type: Constants.PRODUCTS_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const productsExportXlsSuccess = (data) => {
  return {
    type: Constants.PRODUCTS_EXPORT_XLS_SUCCESS,
    data
  }
}

export const productsExportXlsError = (error) => {
  return {
    type: Constants.PRODUCTS_EXPORT_XLS_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Products/actions.js